module.exports = __webpack_public_path__ + "static/media/Straw_Small.64454308.webp";